/* IMECA Foundation theme JS
   - Mobile menu toggle
   - Donation widget (amount presets, custom amount, one-time / monthly)
*/
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      var open = nav.hasAttribute('data-open');
      if (open) {
        nav.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        nav.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Donation widget ---------- */
  function initDonationWidget(root) {
    var form = root.querySelector('form');
    if (!form) return;

    var config;
    try {
      config = JSON.parse(root.querySelector('[data-donation-config]').textContent);
    } catch (e) {
      return;
    }

    var variants = config.variants || [];
    // "Unit" variant (cheapest, evenly divides the presets) -> quantity trick:
    // donation amount = quantity x unit price. Decided server-side in Liquid.
    var unitVariant = null;
    if (config.unitVariantId) {
      unitVariant = variants.filter(function (v) { return v.id === config.unitVariantId; })[0] || null;
    }
    var unitPrice = config.unitPrice || 100;

    var idInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));
    function setVariantId(id) { idInputs.forEach(function (inp) { inp.value = id; }); }
    var qtyInput = form.querySelector('[name="quantity"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var customWrap = root.querySelector('[data-custom-amount]');
    var customInput = customWrap ? customWrap.querySelector('input') : null;
    var presetButtons = Array.prototype.slice.call(root.querySelectorAll('[data-amount-preset]'));
    var freqButtons = Array.prototype.slice.call(root.querySelectorAll('[data-freq]'));

    function selectPreset(btn) {
      presetButtons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    }

    function applyAmount(amount) {
      amount = Math.max(1, Math.floor(amount || 0));
      if (unitVariant) {
        var qty = Math.max(1, Math.round((amount * 100) / unitPrice));
        setVariantId(unitVariant.id);
        qtyInput.value = qty;
        return (qty * unitPrice) / 100;
      } else {
        // Match the closest variant at or above the requested amount.
        var target = amount * 100;
        var best = null;
        variants.forEach(function (v) {
          if (!v.available) return;
          if (best === null) { best = v; return; }
          var dBest = Math.abs(best.price - target);
          var dCur = Math.abs(v.price - target);
          if (dCur < dBest) best = v;
        });
        if (best) { setVariantId(best.id); qtyInput.value = 1; return best.price / 100; }
      }
      return amount;
    }

    presetButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        selectPreset(btn);
        var amount = parseInt(btn.getAttribute('data-amount-preset'), 10);
        if (customInput) customInput.value = amount;
        if (btn.getAttribute('data-variant-id')) {
          setVariantId(btn.getAttribute('data-variant-id'));
          qtyInput.value = 1;
        } else {
          applyAmount(amount);
        }
      });
    });

    if (customInput) {
      customInput.addEventListener('input', function () {
        presetButtons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        var matched = presetButtons.filter(function (b) {
          return parseInt(b.getAttribute('data-amount-preset'), 10) === parseInt(customInput.value, 10);
        })[0];
        if (matched) selectPreset(matched);
        applyAmount(parseInt(customInput.value, 10));
      });
      // On blur, snap the typed amount to the nearest chargeable amount
      // (multiple of the unit variant), so what you see is what you pay.
      customInput.addEventListener('change', function () {
        var actual = applyAmount(parseInt(customInput.value, 10));
        if (actual && parseInt(customInput.value, 10) !== actual) customInput.value = actual;
      });
    }

    freqButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        freqButtons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (planInput) {
          planInput.value = btn.getAttribute('data-freq') === 'monthly' ? (config.sellingPlanId || '') : '';
        }
      });
    });

    form.addEventListener('submit', function () {
      if (customInput && !unitVariant) {
        // amount handled through variant selection; nothing else to do
      } else if (customInput) {
        applyAmount(parseInt(customInput.value, 10));
      }
    });

    // Initialize with default preset (second one, mirrors the $50 default of the design)
    var initial = presetButtons[1] || presetButtons[0];
    if (initial) initial.click();
  }

  document.querySelectorAll('[data-donation-widget]').forEach(initDonationWidget);

  /* ---------- Cart: submit qty changes on change ---------- */
  document.querySelectorAll('[data-cart-form] input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
